import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglepayComponent } from './simple-icons-googlepay.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglepayComponent ],
    exports:      [ SimpleIconsGooglepayComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglepayModule {}
